package data.search_data

import models.SearchData

// Search suggestions (78)
val ChristRedeemerSearchSuggestions = listOf(
    "ivory",
    "blown",
    "cane",
    "hole",
    "vibrated",
    "aerophone",
    "blow",
    "fan",
    "flute",
    "bamboo",
    "lip",
)

// Machu Picchu (366)
val ChristRedeemerSearchData = listOf(
    SearchData(
        1850,
        501336,
        "Flute",
        "flute|bamboo|aerophone-blow hole-end-blown flute (vertical)",
        "mi/mobile-large/midp89.4.720 (2).jpg",
        1.78
    ),
    SearchData(
        1875,
        501319,
        "Pluriarc",
        "pluriarc||chordophone-musical bow",
        "mi/mobile-large/midp89.4.703.jpg",
        0.60
    ),
    SearchData(
        1875,
        501302,
        "Engraved Horn",
        "engraved horn|horn|aerophone-lip vibrated-horn",
        "mi/mobile-large/MUS550A2.jpg",
        0.58
    ),
    SearchData(
        1850,
        502019,
        "Rattle",
        "rattle|fruit or nut shells, fiber rope, cord|idiophone-shaken-rattle",
        "mi/mobile-large/midp89.4.1453.jpg",
        1.78
    ),
    SearchData(
        950,
        319556,
        "Plate",
        "plate|ceramic|ceramics-containers",
        "ao/mobile-large/2005.461_a.jpg",
        1.50
    ),
    SearchData(
        1850,
        502107,
        "Caracasha",
        "caracasha|bamboo, basketry, oxhorn, fiber, rubber or resin|aerophone-lip vibrated-trumpet / trombone",
        "mi/mobile-large/MUS563A21.jpg",
        0.40
    ),
    SearchData(
        1850,
        227759,
        "Handkerchiefs (one of two)",
        "handkerchief||",
        "ad/mobile-large/DP2896.jpg",
        0.95
    ),
    SearchData(
        1850,
        501338,
        "Poo-Do-Parana (flute)",
        "poo-do-parana (flute)|bamboo, dried grass|aerophone-blow hole-side-blown flute (transverse)",
        "mi/mobile-large/midp89.4.722.jpg",
        2.26
    ),
    SearchData(
        1850,
        227758,
        "Handkerchiefs (one of two)",
        "handkerchief||",
        "ad/mobile-large/DP2927.jpg",
        1.01
    ),
    SearchData(
        1850,
        501337,
        "Flute",
        "flute|cane|aerophone-blow hole-end-blown flute (vertical)",
        "mi/mobile-large/midp89.4.721.jpg",
        1.78
    ),
    SearchData(
        1850,
        501335,
        "Flute",
        "flute|bamboo or cane|aerophone-blow hole-side-blown flute (transverse)",
        "mi/mobile-large/midp89.4.719.jpg",
        1.78
    ),
    SearchData(1887, 122578, "Fan", "fan|feathers, ivory|", "ci/mobile-large/CI43.45.1.jpg", 1.09),
    SearchData(
        1850,
        502182,
        "Caracasha",
        "caracasha|gourd, cane or bamboo, basketry, fibercord, rubber or resin|aerophone-lip vibrated-trumpet / trombone",
        "mi/mobile-large/MUS563A19.jpg",
        5.25
    ),
    SearchData(
        1850,
        501334,
        "Whistle",
        "whistle|wood|aerophone-whistle flute-whistle flute",
        "mi/mobile-large/MUS563A5.jpg",
        0.16
    ),
    SearchData(
        1870,
        157985,
        "Fixed fan",
        "fixed fan|ivory, feather|",
        "ci/mobile-large/48.60_front_CP4.jpg",
        0.79
    ),
    SearchData(1887, 122579, "Fan", "fan|feathers, ivory|", "ci/mobile-large/CI43.45.2.jpg", 1.01),
)